import axios from './main'
import routes from './routes'

export const getVideoTag = async (id) => {
  try {
    const { data } = await axios.get(routes.getVideoTag(id))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const putVideoTag = async (id, tags) => {
  try {
    const { data } = await axios.put(routes.putVideoTag(id), tags)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
